if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        if (this.querySelector("form")) {
          this.form = this.querySelector("form");
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        } else {
          this.querySelector("[name=id]").disabled = false;
          this.querySelector("button[type=submit]").addEventListener(
            "click",
            this.onSubmitHandler.bind(this)
          );
        }

        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        //For product card
        const selectedOption = this.closest(".card")?.querySelector(
          ".js-cart-option input:checked"
        );
        if (selectedOption) {
          selectedOption.nextElementSibling.classList.add("loading");
          selectedOption.nextElementSibling
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");

          this.closest(".card--product")
            .querySelectorAll(".js-cart-option input")
            .forEach((input) => {
              if (input != selectedOption) {
                input.classList.add("disabled-loading");
              }
            });
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (!this.form) {
          formData.append("id", this.querySelector("[name=id]").value);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${this.addUrlHandler(routes.cart_add_url)}`, config)
          .then((response) => response.json())
          .then((response) => {
            const parentProductCard = this.closest(".card--product");
            if (parentProductCard) {
              [".card__error", ".card__error--no-options"].forEach(
                (selector) => {
                  const el = parentProductCard.querySelector(selector);
                  if (el) el.innerText = "";
                }
              );
            }

            if (response.status) {
              // dispatch cart:error
              document.dispatchEvent(
                new CustomEvent("cart:error", {
                detail: {
                    source: this.dataset.source,
                    productVariantId: formData.get("id"),
                    errors: response.description,
                    message: response.message
                  }
                })
              );
              // dispatch cart:error

              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              //For product card
              if (parentProductCard) {
                //for color
                //this.submitButton.setAttribute("aria-disabled", true);
                //this.submitButton.setAttribute("disabled", "");
                //this.submitButton.setAttribute("title", window.variantStrings.soldOut );

                //for other option
                //parentProductCard.querySelector('.card__link--add-to-cart_show')?.setAttribute("aria-disabled", true);
                //parentProductCard.querySelector('.card__link--add-to-cart_show')?.setAttribute("disabled", "");
                //parentProductCard.querySelector('.card__link--add-to-cart_show')?.setAttribute("title", window.variantStrings.soldOut);

                const hasOptionsModal =
                  parentProductCard.querySelector(".js-cart-option");
                const cardError =
                  parentProductCard.querySelector(".card__error");
                const cardErrorNoOptions = parentProductCard.querySelector(
                  ".card__error--no-options"
                );
                if (hasOptionsModal && cardError) {
                  cardError.innerText = response.message;
                }

                if (!hasOptionsModal && cardErrorNoOptions) {
                  cardErrorNoOptions.innerText = response.message;
                  cardErrorNoOptions.classList.add("active");
                  setTimeout(() => {
                    cardErrorNoOptions.classList.remove("active");
                  }, 5000);
                }
                this.error = true;
                return;
              }

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            
            // dispatch variant:add
            document.dispatchEvent(
              new CustomEvent("variant:add", {
                detail: {
                  variant: {
                    id: formData.get('id'),
                  },
                  quantity: Number(formData.get("quantity") || 1),
                  formElement: this.form,
                  sectionId: this.dataset.source,
                },
              })
            );
            // dispatch variant:add

            fetch(`${routes.cart_url}.js`)
              .then((response) => {
                return response.text();
              })
              .then((state) => {
                const parsedState = JSON.parse(state);

                // dispatch cart:change for the entire basket
                document.dispatchEvent(
                  new CustomEvent('cart:change', {
                    detail: {
                      cart: parsedState,
                      sectionId: this.dataset.source
                    }
                  })
                );
                // dispatch cart:change for the entire basket
              })
              .catch((error) => {
                console.error('Error fetching cart state:', error);
              });

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
              });
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            //For product card
            if (this.closest(".card--product")) {
              this.submitButton.removeAttribute("aria-disabled");
            }
            if (selectedOption) {
              selectedOption.nextElementSibling.classList.remove("loading");
              selectedOption.nextElementSibling
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");

              if (!this.error) {
                selectedOption
                  .closest(".js-cart-option")
                  .classList.remove("active");
                const quickAddBtn = selectedOption
                  .closest(".card--product")
                  .querySelector(".card__link--add-to-cart_show");
                if (quickAddBtn) quickAddBtn.style.opacity = 1;
                const quickViewBtn = selectedOption
                  .closest(".card--product")
                  .querySelector(".card__quick-view_mobile");
                if (quickViewBtn) quickViewBtn.style.opacity = 1;
              }

              this.closest(".card--product")
                .querySelectorAll(".js-cart-option input")
                .forEach((input) => {
                  input.classList.remove("disabled-loading");
                  input.checked = false;
                });
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      addUrlHandler(url) {
        if (url === "/cart/add") {
          return "/cart/add.js";
        }

        return url;
      }
    }
  );
}
